import {ControlType} from '../enums';
import {ValidatorFn} from '@angular/forms';
import {OptionItem, OptionProvider} from '@twpub/core/models/field-props';

/**
 * Base class for defining field types for editing the model for a component in the search ui.
 */
export class ComponentFieldModel<T> {
  value?: T;
  key: string;
  label: string;
  description: string;
  required: boolean;
  order: number;
  controlType: ControlType;
  options: OptionItem[] | OptionProvider;
  multiple: boolean;
  dependencyFlag?: string;
  validators: ValidatorFn[];
  validationMessage: string;

  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    description?: string;
    required?: boolean;
    order?: number;
    controlType?: ControlType;
    options?: OptionItem[] | OptionProvider;
    multiple?: boolean;
    dependencyFlag?: string;
    validators?: ValidatorFn[];
    validationMessage?: string;
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.description = options.description || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || ControlType.None;
    this.options = options.options || [];
    this.multiple = !!options.multiple;
    this.dependencyFlag = options.dependencyFlag;
    this.validators = options.validators || [];
    this.validationMessage = options.validationMessage || '';
  }
}
